module.exports = __webpack_public_path__ + "img/4_CirTraz.dad464b2.png";